import { Icon } from '@/common/components';
import { Box } from '@mui/material';

import './IconDivider.scss';

type Props = {
  icon: string;
  label?: string;
};

const IconDivider = ({ icon, label }: Props) => {
  return (
    <Box className="icon-divider">
      <Icon name={icon} />
      {label}
    </Box>
  );
};

export default IconDivider;
